import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ThinkyPlay from './components/ThinkyPlay.tsx';
import ThinkyPlayLanding from './components/ThinkyPlayLanding.js';
import AccountPage from './components/AccountPage.jsx';
import SchoolsPage from './components/schools.tsx';
import Ranking from './components/SchoolRanking.tsx'; // Add this import
import NotFound from './components/NotFound.js'; // Add this import

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<ThinkyPlayLanding />} />
          <Route path="/play" element={<ThinkyPlay />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/schools" element={<SchoolsPage />} />
          <Route path="/schoolwars" element={<Ranking />} />
          <Route path="*" element={<NotFound />} /> {/* Add this catch-all route */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;